import {Component, Input, OnDestroy} from '@angular/core';
import {Subject} from 'rxjs';
import {SummaryBalanceWrapper} from '../../../interfaces/summaryBalance';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';



@Component({
    selector: 'app-summary-balance-v2',
    templateUrl: './summary-balance-component-v2.component.html',
    styleUrls: ['./summary-balance-component-v2.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        RouterModule
    ]
})
export class SummaryBalanceV2Component implements OnDestroy {

    private unsubscribe$ = new Subject();

    @Input() budgetId;
    @Input() budget;
    @Input() summary: SummaryBalanceWrapper;

    public ngOnDestroy() {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    }

    compare(a: number, b: number) {
        return a > b;
    }

    getGenExpProfitDiff(summary) {
        return Math.abs(summary.costSummary.profit.final - summary.costSummary.profit.budget);
    }

}